import React from 'react';
import Label from './Label';

let TextArea = ({
    input,
    label,
    type,
    meta: { touched, error, warning },
    placeholder
}) => {

    return (
        <>
            <div>
                <Label name={label} />
                <textarea {...input} placeholder={placeholder} type={type} className="form-control text-area" />
            </div>
            {touched && (error &&
                <div className="row" style={{ textAlign: "right" }}>
                    <div className="col-md-12 float-right">
                        <span>
                            <small>{error}</small>
                        </span>
                    </div>
                </div>
            )}
        </>
    )
}

export default TextArea
